import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

var checkboxStyles = function checkboxStyles(theme) {
  return {
    check: {
      fillRule: 'nonzero',
      fill: "".concat(theme.ds.palette.neutral.dark),
      stroke: "".concat(theme.ds.palette.neutral.dark)
    }
  };
};

var Indeterminate = function Indeterminate(_ref) {
  var classes = _ref.classes;
  return (
    /*#__PURE__*/
    React.createElement(SvgIcon, {
      style: {
        width: 20,
        height: 20
      }
    },
    /*#__PURE__*/
    React.createElement(Fragment, null,
    /*#__PURE__*/
    React.createElement("g", {
      transform: "translate(1 1)"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      className: "ds_switch_outline",
      width: "22",
      height: "22"
    }),
    /*#__PURE__*/
    React.createElement("g", {
      transform: "translate(2,2)"
    },
    /*#__PURE__*/
    React.createElement("polygon", {
      className: classes.check,
      points: "14.25 9.75 3.75 9.75 3.75 8.25 14.25 8.25"
    })))))
  );
};

export var IndeterminateIcon = withStyles(checkboxStyles)(Indeterminate);